import {
  CalendarDays,
  Inbox,
  LayoutDashboard,
  ListTodo,
  MessagesSquare,
  MessageSquare,
  Receipt,
  Settings,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { ClinicNavItemDef } from '@/components/Layout/sidebarNav';

export const NAV_ICONS: Record<ClinicNavItemDef['icon'], LucideIcon> = {
  home: LayoutDashboard,
  patients: Users,
  messages: MessageSquare,
  referrals: Inbox,
  medcom: MessagesSquare,
  appointments: CalendarDays,
  tasks: ListTodo,
  economy: Receipt,
  settings: Settings,
};
